import { ADD_THOUGHT_LEADER, CHANGE_STATUS, DELETE_THOUGHT_LEADER, SET_THOUGHT_LEADER, UPDATE_THOUGHT_LEADER } from "../constants";

const initialState = [];

export const thoughtLeaderReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_THOUGHT_LEADER: {
            state = [...payload];
            return state;
        }
        case CHANGE_STATUS: {
            let temp = [...state];
            let index = temp.findIndex(thoughtLeader => thoughtLeader._id === payload);
            if (index > -1) {
                temp[index].status = temp[index].status === 'Live' ? 'Disabled' : 'Live';
            }
            return temp;
        }
        case ADD_THOUGHT_LEADER: {
            state = [{ ...payload }, ...state];
            return state;
        }
        case UPDATE_THOUGHT_LEADER: {
            let temp = [...state];
            let index = temp.findIndex(thoughtLeader => thoughtLeader._id === payload._id);
            if (index > -1) {
                temp[index] = payload;
            }
            return temp;
        }
        case DELETE_THOUGHT_LEADER: {
            let temp = [...state];
            let index = temp.findIndex(thoughtLeader => thoughtLeader._id === payload);
            if (index > -1) {
                temp.splice(index, 1);
            }
            return temp;
        }
        default: {
            return state
        }
    }
};